import {createApi} from '@reduxjs/toolkit/query/react';
import baseQuery from 'src/redux/api/baseQuery';
import { ObtenerActividadesRequest, ObtenerActividadesResponse } from './types/actividades';

/**
 * API para la gestión de actividades de producto de proyecto
 * @see https://redux-toolkit.js.org/rtk-query/overview
 * @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
 *
 */
export const actividadesApi = createApi({
	reducerPath: 'actividadesApi',
	baseQuery,
	tagTypes: ['actividades'],
	endpoints: (builder) => ({
		obtenerActividades: builder.query<ObtenerActividadesResponse, ObtenerActividadesRequest>({
			query({productoId, paginador}) {
				return {
					url: 'v1/actividades',
					method: 'GET',
					credentials: 'include',
					params: {
						productoId,
						...paginador
					}
				};
			},
		}),
	}),
});

export const {
	useObtenerActividadesQuery
} = actividadesApi;
